import { Expose } from 'class-transformer';

export class FsSharedCameraStats {
  @Expose()
  public totalRegisteredCameras: number;

  @Expose()
  public totalIntegratedCameras: number;

  @Expose()
  public totalOwnedCameras: number;

  @Expose()
  public totalSharedCameras: number;

  @Expose()
  public totalMaxCameras: number;

  constructor() {}
}
